import SettingsPageContent from "components/Design/Settings/SettingsPageContent";
import React from "react";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import { Routing } from "../../data/Constants/Routing";
import RoleForm from "./RoleForm";

const CreateRoleScreen: React.FC = () => {
    return (
        <SettingsPage
            breadcrumbs={[{
                title: "Rollen",
                link: Routing.Administration.Role.Navigate()
            }]}
            title="Rolle anlegen">

            <SettingsPageContent>

                <RoleForm scenario={undefined} />

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default CreateRoleScreen;
